import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { initBlock, resetBlock, reportDWH } from './electricCompanyLeadBlockSlice';
import ProgressBar from '../../Shared/ProgressBar/progressBar';
import OtpFormPage from './Pages/OtpFormPage';
import OtpVerifyCodePage from './Pages/OtpVerifyCodePage';
import ServiceMessagePage from './Pages/ServiceMessagePage';

const ElectricCompanyLead = (props) => {
  let currentView = null;

  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'Check Counter - Display' });
      props.initBlock({ cmsBlockData: props.iContent });
    }
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
      }
    };
  }, []);

  useClearStateResetFlag();

  switch (props.page) {
    case 'otpFormPage': currentView = <OtpFormPage />; break;
    case 'otpVerifyCodePage': currentView = <OtpVerifyCodePage/>; break;
    case 'serviceMessagePage': currentView = <ServiceMessagePage />; break;
  }

  return (
    <>
      <ProgressBar points={props.progressBarPoints} percent={props.pagePercent} />
      <div className='electric-company-lead-block'>{currentView}</div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.electricCompanyLeadBlock.page,
    pagePercent: state.electricCompanyLeadBlock.pagePercent,
    progressBarPoints: state.electricCompanyLeadBlock.progressBarPoints
  };
};

const mapDispatchToProps = {
  initBlock,
  resetBlock, 
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(ElectricCompanyLead);
